// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3i3SI","unreadBadge":"styles_unreadBadge__2CgAn","modalContent":"styles_modalContent__3SlFX","modal":"styles_modal__2aj21"};